import React from 'react'
import { Subheading } from '../HeadingModule/Subheading'
import '../../styles/ConciergeModule/GreetingSubheading.scss'

interface GreetingSubheadingProps {
  subheading: string
  fallback: string
  mobileSubheading?: string
}

export const GreetingSubheading = ({ subheading, fallback, mobileSubheading }: GreetingSubheadingProps) => {
  return <div className="greeting-subheading">
        <span className="greeting-subheading__desktop">
          <Subheading text={subheading || fallback} />
        </span>
        {mobileSubheading && (
          <span className="greeting-subheading__mobile">
            <Subheading text={mobileSubheading || fallback} />
          </span>
        )}
    </div>
}
